import React from 'react';
import { Modal } from 'react-bootstrap';
import TranslateFile from '../../../../../config/TranslateFile';

const EmailVerificationModal = ({
  show,
  onHide, 
  title,
  message,
  messageHTML,
  messageColor = "#212529",
  size = "",
  onNewEmailVerify,
  onWithoutEmailUpdate,
  closeButton = true
}) => {

  const currentLang = TranslateFile();

  return (
    <Modal show={show} onHide={onHide} centered size={size} backdrop="static" keyboard={false} >
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {messageHTML ? (
          <p
            dangerouslySetInnerHTML={{
              __html: messageHTML,
            }}
          />
        ) : (
          <h5 style={{ color: messageColor }}>{message}</h5>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-success" onClick={onNewEmailVerify}>
       {currentLang?.labels?.Verify_New_Email}
        </button>
          <button className="btn btn-warning" onClick={onWithoutEmailUpdate}>
          {currentLang?.labels?.Update_ProfileInfo_Except_Email}
          </button>
          <button className="btn btn-danger" onClick={onHide}>
            {currentLang?.buttons?.Cancel}
          </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailVerificationModal;
